import { Position } from '@ui/services/contract/hooks/TradingReaderFacet/useGetPositionV2/types';
import { Nullable } from '@ui/types/utility';
import { create } from 'zustand';

type State = {
  position: Nullable<Position>;
};

type Store = State & {
  set: (change: Partial<State>) => void;
};

export const useChartLineStore = create<Store>((set) => ({
  position: null,
  set(change) {
    set(change);
  },
}));
